import { createEvent, createStore, sample } from 'effector'
import { onRouteChangeStart } from '@entities/route/model'

export const setSuggestions = createEvent<string>()
export const clearSuggestions = createEvent()
export const $currentSuggestionId = createStore<string>('')
    .on(setSuggestions, (_, sugId) => sugId)
    .reset(clearSuggestions)

sample({
    clock: onRouteChangeStart,
    target: clearSuggestions
})
